import React, { Fragment } from "react";
import { FormGroup, Button, HelpBlock } from "react-bootstrap";
import Popup from "reactjs-popup";

const MfaSelectionPopup = ({ isOpen, onClose, onSelectMfaType }) => {
  return (
    <Fragment>
      <Popup
        contentStyle={{
          width: "590px",
          borderRadius: "15px",
          padding: "15px",
          minWidth: "590px !important",
        }}
        open={isOpen}
        modal
        closeOnDocumentClick={false}
        onClose={onClose}
      >
        <div>
          {/* eslint-disable-next-line */}
          <a className="close" onClick={onClose}>
            &times;
          </a>
          <div>
            <FormGroup>
              <HelpBlock>
                Please select your preferred Multi-Factor Authentication method:
              </HelpBlock>
            </FormGroup>
            <FormGroup className="text-center">
              <Button
                bsSize="large"
                bsClass="btn btn-outline-primary m-2"
                onClick={() => onSelectMfaType("TOTP")}
              >
                Authenticator App (TOTP)
              </Button>
              <Button
                bsSize="large"
                bsClass="btn btn-outline-primary m-2"
                onClick={() => onSelectMfaType("SMS")}
              >
                SMS Text Message
              </Button>
            </FormGroup>
            <FormGroup>
              <HelpBlock>
                <strong>Authenticator App:</strong> Uses an app like Google
                Authenticator or Authy to generate time-based codes.
              </HelpBlock>
              <HelpBlock>
                <strong>SMS Text Message:</strong> Sends verification codes to
                your registered mobile phone.
              </HelpBlock>
            </FormGroup>
          </div>
        </div>
      </Popup>
    </Fragment>
  );
};

export default MfaSelectionPopup;
